export default __webpack_public_path__ + "static/media/smiling-face-with-hearts.edc8f043.svg";